import { Helmet } from "react-helmet-async";

import {
  DEFAULT_OG_IMAGE_PATH,
  SITE_NAME,
  absoluteUrl,
  truncateMetaDescription,
} from "./siteConfig";

/**
 * @param {{
 *   title: string;
 *   description: string;
 *   path: string;
 *   noIndex?: boolean;
 *   ogImagePath?: string;
 * }} props
 */
function SeoHead({ title, description, path, noIndex = false, ogImagePath }) {
  const canonical = absoluteUrl(path);
  const desc = truncateMetaDescription(description);
  const imageUrl = absoluteUrl(ogImagePath || DEFAULT_OG_IMAGE_PATH);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noIndex ? <meta name="robots" content="noindex" /> : null}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}

export default SeoHead;
